import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = props => /*#__PURE__*/_jsx("svg", {
  viewBox: "0 0 24 24",
  width: "1em",
  height: "1em",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M22.842 22.659l-5.145-5.146c1.89-1.785 3.045-4.305 3.045-7.14 0-5.461-4.41-9.872-9.87-9.872S1 4.911 1 10.372s4.41 9.871 9.871 9.871a10 10 0 005.986-1.995l5.25 5.146c.105.105.21.105.315.105.105 0 .315 0 .42-.105a.508.508 0 000-.735zm-11.97-3.466c-4.937 0-8.822-3.99-8.822-8.82S6.04 1.55 10.871 1.55s8.821 3.99 8.821 8.821c.105 4.83-3.885 8.821-8.82 8.821z"
  })
});
export default SvgSearch;